import { Link } from 'react-router-dom';
import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-inner">
            <small className="footer-line">
                VoyCalc AS · Org. nr. 938 332 959 · Lindbackveien 9D, 1163 Oslo, Norway
            </small>
            <small className="footer-line">
                <Link to="/?page=terms" className="text-white">Terms of Use</Link>
                {' · '}
                <Link to="/?page=privacy" className="text-white">Privacy Policy</Link>
                {' · '}
                <Link to="/?page=cookies" className="text-white">Cookie Policy</Link>
                {' · '}
                <Link to="/?page=terms#data-sources" className="text-white">Data sources</Link>
                {' · '}
                <a href="mailto:hello@voycalc.com" className="text-white">Contact</a>
            </small>
            <small className="footer-line">
                Weather data generated using E.U. Copernicus Marine Service Information.
            </small>
            <small className="footer-line">
                © 2026 VoyCalc AS
            </small>
            </div>
        </footer>
    );
}

export default Footer;
